import * as go from 'gojs'
import { layoutGroupSpacing, layoutNodeSpacingAdjustmentForBadge } from '@/utils/constants'

export default function SquareLayout () {
  go.GridLayout.call(this)
  this.isViewportSized = false
}

go.Diagram.inherit(SquareLayout, go.GridLayout)

SquareLayout.prototype.doLayout = function (coll) {
  var ecoll = this.collectParts(coll)
  const parts = []
  ecoll.each(p => {
    parts.push(p)
  })
  parts.sort(this.comparer)
  const padding = this.group.placeholder.padding
  let topLeft = this.group.placeholder.getDocumentPoint(go.Spot.TopLeft)
  topLeft.x += padding.left
  topLeft.y += padding.top
  var tot = 0
  var spac = this.spacing
  parts.forEach(function (p) {
    if (p instanceof go.Link) return
    const fudgeAmount = p.data.isGroup ? 0 : layoutNodeSpacingAdjustmentForBadge
    tot += (p.actualBounds.width + spac.width) * (p.actualBounds.height + fudgeAmount + spac.height)
  })
  if (tot !== 0) {
    let wrappingWidth = Math.sqrt(tot)
    let rowWidth = 0
    let rowHeight = 0
    let x = topLeft.x
    let y = topLeft.y
    parts.forEach(function (p) {
      if (p instanceof go.Link) return
      if (rowWidth + p.actualBounds.width > wrappingWidth) {
        y += rowHeight + spac.height
        rowHeight = 0
        rowWidth = 0
        x = topLeft.x
      }
      if (p.data.isGroup) {
        y += layoutGroupSpacing
      }
      p.moveTo(x, y)
      x += p.actualBounds.width + spac.width + layoutNodeSpacingAdjustmentForBadge
      rowWidth += p.actualBounds.width + spac.width + layoutNodeSpacingAdjustmentForBadge
      const fudgeAmount = p.data.isGroup ? 0 : layoutNodeSpacingAdjustmentForBadge
      rowHeight = Math.max(rowHeight, p.actualBounds.height + fudgeAmount)
    })
  }
}



// WEBPACK FOOTER //
// ./src/graph_parts/square_layout.js